import { AxiosError, AxiosRequestConfig } from "axios";
import {
  captureExceptionWithSentry,
  setAuthorizationHeaderOnConfig,
  shouldErrorBeReported,
  userFriendlyErrorMessage,
} from "@defa-as/utils";
import { orderModule } from "@/store/modules/order-module";
import { errorModule } from "@/store/modules/error-module";
import { userModule } from "@/store/modules/user-module";

export const requestInterceptorAddAuthorizationHeader = (
  config: AxiosRequestConfig
) => setAuthorizationHeaderOnConfig(config, userModule.token);

export const responseInterceptorReportError = async (error: AxiosError) => {
  if (shouldErrorBeReported(error)) {
    errorModule.setError({ error: userFriendlyErrorMessage(error) });
    captureExceptionWithSentry(error, orderModule.id);
  }
  throw error;
};
